<template>
  <div class="usermanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;" border>
      <el-table-column prop="createAtMY" label="时间" width="190"></el-table-column>
      <el-table-column prop="createUserInfoName" label="用户"></el-table-column>
      <el-table-column prop="theme" label="下载的资源">
        <template slot-scope="scope">
          <div v-if="scope.row.type == 'picture'">
            <el-image
              style="width: 50px; height: 50px;"
              :src="scope.row.picThumbWh160"
              :preview-src-list="[scope.row.savepath]"
              fit="cover"></el-image>
          </div>
          <div v-if="scope.row.type == 'video'">
            <div class="video" @click.stop="playVideo(scope.row)" :style="{ backgroundImage: 'url(' + scope.row.picThumbWh160 + ')', backgroundSize: 'contain', backgroundPosition: 'center center'}">
              <div class="play">
                <img src="@/assets/piclist/play.png" alt="">
              </div>
            </div>
          </div>
          <div v-if="scope.row.type == 'document'">
            <div @click.stop="openDocument(scope.row)">
              <span style="cursor: pointer;color:#185ED3;font-weight:bold;font-size:13px;">{{scope.row.documentTitle}}</span>
            </div>
          </div>
        </template>
      </el-table-column>


      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="moreClick(scope)" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small">查看更多</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog
      title="视频播放"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <div>
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      style="width:100%;height:100%;"
                      :playsinline="true"
                      :options="playerOptions"></video-player>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {userTabletype,userTablemode} from '@/constants/tablecommon'
import { listAuthRole } from "@/api/authRole";
import { picPrefix } from "@/constants/piccommon";
export default {
  name: "usermanagetable",
  props: {
    tableData: Array
  },
  data() {
    return {
      picPrefix,
      dialogVisible:false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
    };
  },
  methods: {
    moreClick(scope) {
      this.$emit("moreClick", scope.row);
    },

    handleClose(){
      this.dialogVisible = false
    },
    playVideo(e){
      this.playerOptions.sources[0].src = e.savepath
      this.dialogVisible = true
    },

    openDocument(e){
      if(e.documentSrc.indexOf('http') == -1){
        window.open( "https://view.xdocin.com/view?src=" + this.picPrefix +  e.documentSrc , "_target");
      }else{
        window.open( "https://view.xdocin.com/view?src=" + e.documentSrc , "_target");
      }
    },

  },
  created() {
    // this.listAuthRoleAsync()
    
  },
  mounted(){
    // console.log(this.tableData)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover{
  text-decoration: underline;
}
.video{
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
/deep/ .vjs-custom-skin .video-js .vjs-big-play-button{
            width: 78px;
            height: 78px !important;
            border-radius: 50%;
            outline: none;
            border: none;
            background: url('~@/assets/piclist/playb.png') no-repeat, transparent;
}
/deep/ .vjs-custom-skin .video-js .vjs-big-play-button .vjs-icon-placeholder::before {
                content: none;
            }

/deep/ .el-dialog__header {
  height: 0;
}
/deep/ .el-dialog__body {
  padding: 20px;
}
</style>
